import { DescriptionRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IBooking } from "../../../../../types";

const CellActions = (params: ICellRendererParams<IBooking>) => {

    const { t } = useTranslation('booking');

    return (
        <Link to={`/booking/view/${params.data?.id}`} target="_blank">
            <IconButton title={t('label.details')} color="accent">
                <DescriptionRounded />
            </IconButton>
        </Link>
    );
};

export default CellActions;